import { createBrowserHistory } from 'history';

export type { Location, PartialPath, Path, To } from 'history';

export default createBrowserHistory();

export const uriChangeHandled = 'uri change handled';
